import ContainerPage from '@componentsNew/ContainerPage';
import { CardStep } from './CardStep';
import { CardArtigo } from './CardArtigo';
import { FiShare2, FiTool } from 'react-icons/fi';
import { TfiDownload } from 'react-icons/tfi';
import IconCard from '@componentsNew/StepIcon/IconCard';
import { CardSugestoes } from './CardSugestoes';
import Button from '@componentsNew/Button';
import Typography from '@componentsNew/Typography';
import { EditorComponent } from './Editor';
import { useIntegracao } from './Context/IntegracaoContext';
import { useEffect, useState } from '@wordpress/element';
import NotificationHub from '@componentsNew/Notification';
import CircularProgress from '@componentsNew/CircularProgress';
import { ContextTelaProvider } from '@pages/DicasOtimizacao/telaContext';

export function ArtigoIA() {
  const [conteudo, setConteudo] = useState({});
  const [blocosEmEdicao, setBlocosEmEdicao] = useState(null);
  const [step, setStep] = useState(1);
  const [paragrafo, setParagrafoGerado] = useState(null);
  const [setarLoading, setSetarLoading] = useState(false);
  const [desconectar, setDesconectar] = useState(false);
  const [connectionId, setConnectionId] = useState(null);

  const { carregando, publicar, salvarRascunho, setPalavrasChave } = useIntegracao();

  useEffect(() => {
    if (blocosEmEdicao === null) {
      const rascunhoString = localStorage.getItem('artigo_em_edicao');

      if (rascunhoString) {
        const rascunho = JSON.parse(rascunhoString);
        const blocos = JSON.parse(rascunho?.conteudo);

        setPalavrasChave(rascunho?.palavras_chave);
        localStorage.setItem('id_artigo_ia', parseInt(rascunho?.id));
        if (rascunho?.imagem) {
          blocos?.blocks.splice(1, 0, {
            type: 'image',
            data: {
              url: `data:image/png;base64,${rascunho?.imagem}`,
            },
          });
        }
        setBlocosEmEdicao(blocos);
      }
    }

    if (blocosEmEdicao !== null && blocosEmEdicao?.blocks?.length !== 0) setStep(5);
  }, [blocosEmEdicao]);

  const handleConnection = id => setConnectionId(id);

  const handleParagrafo = paragrafo => {
    setParagrafoGerado(paragrafo);

    if (paragrafo.titulo == 'imagem') {
      setDesconectar(true);
    }

    if (!setarLoading) {
      setSetarLoading(true);
    }
  };

  return (
    <ContextTelaProvider>
      <ContainerPage
        titulo="Novo artigo"
        componenteLateral={
          <div className="gap-4 flex items-center ">
            <IconCard>
              <FiTool className="w-6" />
            </IconCard>
            <IconCard>
              <TfiDownload className="w-6" />
            </IconCard>
            <IconCard>
              <FiShare2 className="w-6" />
            </IconCard>
            {step == 5 && (
              <Button
                className="min-w-38"
                component="outlined"
                disabled={carregando.rascunho}
                onClick={salvarRascunho}
              >
                <Typography component="button">
                  {carregando.rascunho ? 'Salvando...' : 'Salvar Rascunho'}
                </Typography>
              </Button>
            )}
            {step == 5 && (
              <Button className="min-w-38" disabled={carregando.publicar}>
                <Typography component="button" onClick={publicar}>
                  {carregando.publicar ? 'Publicando...' : 'Publicar'}
                </Typography>
              </Button>
            )}
          </div>
        }
      >
        {!desconectar && (
          <NotificationHub setParagrafoGerado={handleParagrafo} setConnectionHub={handleConnection} />
        )}

        <div className="flex gap-4 items-start"></div>

        <div className="flex gap-4 items-start mb-4">
          {step <= 4 && !setarLoading && (
            <CardStep
              step={step}
              setarLoading={setarLoading}
              connectionId={connectionId}
              setConteudo={setConteudo}
              setStep={setStep}
            />
          )}

          {!paragrafo &&
            (blocosEmEdicao?.blocks == undefined || blocosEmEdicao?.blocks?.length == 0) && (
              <CardArtigo />
            )}

          <div
            style={{
              display: 'flex',
              flexDirection: 'column-reverse',
              borderRadius: '1rem',
              marginRight: '3rem',
              width: '80%',
              paddingLeft: '2rem',
              paddingRight: '2rem',
              backgroundColor: 'white',
              boxShadow: '0px 0px 4px 0px #00000040',
              display: paragrafo || blocosEmEdicao?.blocks?.length > 0 ? 'flex' : 'none',
            }}
          >
            {!desconectar && (
              <>
                {/* -20Rem é necessário para que o Loading fique próximo ao texto sendo gerado, não causa bugs, mas não tem outra forma */}
                <div
                  style={{ marginTop: '-20rem', marginBottom: '5rem' }}
                  className="flex flex-col items-center"
                >
                  <CircularProgress className="mt-8" />
                  <p className="text-center mt-4">✍️ Aguarde, o Texto está sendo criado...</p>
                </div>
              </>
            )}
            <br />
            <br />
            <EditorComponent paragrafoGeradoStreaming={paragrafo} />
          </div>

          <div
            style={{ display: paragrafo || blocosEmEdicao?.blocks?.length > 0 ? 'block' : 'none' }}
            className={`rounded-2xl shadow-[0px_0px_4px_0px_rgba(0,0,0,0.20)] bg-neutras-white p-8 w-3/6`}
          >
            <CardSugestoes step={step} setStep={setStep} />
          </div>
        </div>
      </ContainerPage>
    </ContextTelaProvider>

  );
}
